import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import { useAccesos } from '../contexts/AccesosContext';
function AddEtnia({ handleNewEtnia, editEtnia }) {
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [descripcion, setDescripcion] = useState('');
    const [IngresadoPor, setIngresadoPor] = useState('');
    const [modificacion, setModificacion] = useState('');
    const { user } = useUser();
    const { tienePermiso } = useAccesos();
    function obtenerFechaISOsinZ() {
        const fecha = new Date();
        let fechaISO = fecha.toISOString(); // "2024-07-30T22:14:46.271Z"
        fechaISO = fechaISO.slice(0, -1); // Elimina la última posición, que es la 'Z'
        return fechaISO;
    }

    // Convertir a una cadena en formato ISO 8601
    const fechaFormateada = obtenerFechaISOsinZ();
    useEffect(() => {
        if (editEtnia) {
            setDescripcion(editEtnia.descripcion); // Cargar la descripción de la etnia para editar
            setModificacion(2);
            setIngresadoPor(editEtnia.ingresadoPor);

        } else {
            setDescripcion(''); // Resetear la descripción si no estamos editando
            setModificacion(1);
            setIngresadoPor('');

        }
    }, [editEtnia]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const method = editEtnia ? 'PUT' : 'POST';
        const endpoint = editEtnia ? `${server}/MgEtnias/${editEtnia.id}` : `${server}/MgEtnias`;

        const etnia = {
            id:editEtnia ? editEtnia.id:0,
            descripcion,
            IngresadoPor: !editEtnia ? (user ? user.codigoUsuario : 'ADMIN               ') : IngresadoPor,
            ModificadoPor: editEtnia ? (user ? user.codigoUsuario : 'ADMIN               ') : undefined,
        
        };
        Object.keys(etnia).forEach(key => etnia[key] === undefined && delete etnia[key]);

        try {
            const response = await fetch(endpoint, {
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(etnia),
            });

            if (response.ok) {
                // Limpiar el formulario y manejar la respuesta si es necesario
                setDescripcion('');
                Swal.fire({
                    icon: 'success',
                    title: 'Operación exitosa',
                    showConfirmButton: false,
                    timer: 1500
                });
                handleNewEtnia();
            } else {
                const errorData = await response.json();
                const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                Swal.fire({
                    icon: 'error',
                    title: `Error ${response.status}`,
                    text: errorMessage,
                });
            }
        } catch (error) {
            console.error('Error al procesar la etnia:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error al guardar etnia',
                text: error || 'Ocurrió un error inesperado',
            });
        }
    };

    return (
        <>
            <h2>{editEtnia ? 'Editar Etnia' : 'Agregar Nueva Etnia'}</h2>
            <br />
            <form id="formEtnia" className="form-horizontal form-label-left" onSubmit={handleSubmit}>
                <div className="item form-group">
                    <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="descripcionEtnia">
                        Descripción: <span className="required">*</span>
                    </label>
                    <div className="col-md-2 col-sm-3">
                        <input
                            type="text"
                            id="descripcionEtnia"
                            required="required"
                            className="form-control"
                            value={descripcion}
                            onChange={(e) => setDescripcion(e.target.value)}
                        />
                    </div>
                </div>

                <div className="ln_solid" />
                <div className="item form-group">
                    <div className="col-md-6 col-sm-6 offset-md-3">
                        <button type="submit" className="btn btn-success" disabled={!tienePermiso('Crear Etnia')}>
                            {editEtnia ? 'Actualizar' : 'Guardar'}
                        </button>
                    </div>
                </div>
            </form>
        </>
    )
}

export default AddEtnia;
